const popupHomographStyle = (theme) => ({
  root: {
    maxWidth: '360px',
    backgroundColor: theme.palette.background.paper,
  },
})

export default popupHomographStyle
